<template>
  <div>
    <v-form @submit.prevent="submitResponse">
      <p class="mb-3">
        If you weighed out
        <number-value :value="massCa" unit="\text{g}" />
        of calcium and reacted it with an excess of
        <chemical-latex content="HCl," />
        how many moles of
        <chemical-latex content="H2" />
        would you expect to produce?
      </p>

      <calculation-input
        v-model="inputs.studentAnswer"
        prepend-text="$\ce{H2}:$"
        append-text="$\text{mol}$"
        :disabled="!allowEditing"
      />
    </v-form>
  </div>
</template>

<script>
import DynamicQuestionMixin from '../../mixins/dynamic-question';
import CalculationInput from '../inputs/CalculationInput';
import NumberValue from '../NumberValue';
import StembleLatex from '@/tasks/components/StembleLatex';
import ChemicalLatex from '@/tasks/components/displayers/ChemicalLatex.vue';

export default {
  name: 'OleMiss116PRL2_Q2part2',
  components: {
    ChemicalLatex,
    CalculationInput,
    NumberValue,
    StembleLatex,
  },
  mixins: [DynamicQuestionMixin()],
  data() {
    return {
      inputs: {
        studentAnswer: null,
      },
    };
  },
  computed: {
    massCa() {
      return this.taskState.getValueBySymbol('massCa').content;
    },
  },
};
</script>
